exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectRate[data-v-4f7a5f10]{\r\n  padding: 10px 15px;\r\n  color: #323233;\r\n  font-size: 0.37333rem;\n}\r\n", ""]);

// exports
